import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColorMode, ColorModeRequest, ColorModeResponse } from '../models/color-mode.model';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class ColorModeService {
  private readonly endpoint: string;

  constructor(
    private readonly http: HttpClient,
    environmentService: EnvironmentService,
  ) {
    this.endpoint = `${environmentService.apiUrl.replace(/\/$/, '')}/api/User/me/color-mode`;
  }

  getColorMode(): Observable<ColorModeResponse> {
    return this.http.get<ColorModeResponse>(this.endpoint);
  }

  saveColorMode(mode: ColorMode): Observable<ColorModeResponse> {
    const request: ColorModeRequest = { mode };
    return this.http.put<ColorModeResponse>(this.endpoint, request);
  }
}
